import { Helmet } from 'react-helmet';
import ProcessTimeline from '../components/ProcessTimeline';
import ServicesTabs from '../sections/ServicesTabs';

export default function ServicesPage() {
  return (
    <main>
      <Helmet>
        <title>Services | Carter Asset Management</title>
      </Helmet>
      <section className="section-container section-spacing">
        <header className="max-w-3xl space-y-4 md:space-y-6">
          <p className="text-sm font-semibold uppercase tracking-wide text-cam-blue/70">Our Services</p>
          <h1 className="text-3xl md:text-5xl font-semibold tracking-tight text-cam-blue">
            A cohesive experience across planning, investing, and advanced strategy.
          </h1>
          <p className="text-base text-slate-600">
            Begin with clarity. Each engagement is designed around your priorities, with transparent communication and proactive implementation.
          </p>
        </header>

        <div className="mt-10">
          <ServicesTabs />
        </div>
      </section>
      <ProcessTimeline />
    </main>
  );
}
